import React, { useState, useEffect } from "react";
import api from "../../../services/api.js";

import IconWarning from "../../../assets/icons/icon-warning-red.png";
import Location from "../../../assets/icons/icon-location-icon.svg";
import * as S from "./styles.js";
import Tooltip from "../../tooltip";
import { Auxiliar, TaglineP } from "../../../styles/stylesTypography.js";
import { theme } from "../../../styles/theme.js";

const NewCardNotificationFarm = ({ farmId }) => {
    const [alert, setAlert] = useState(null);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (!farmId || farmId === 0 || farmId === undefined || farmId === null) return

        const fetchAlerts = async () => {
            try {
                const response = await api.get("/clima/alertas-geral");

                if (response.data.code === 422) {
                    setHasError(true);
                } else {
                    const filteredAlert = response.data.data.find(item => item.farm_id === Number(farmId));
                    setAlert(filteredAlert || null);
                    setHasError(false);
                }
            } catch (error) {
                setHasError(true);
            }
        };

        fetchAlerts();
    }, [farmId]);

    if (hasError || !alert) {
        return null;
    }

    return (
        <S.Container>
            <S.Wrapper>
                <S.CardNotification onClick={() => window.location = `/fazendas/${alert.farm_id}/${alert.producer_id}`}>
                    <S.ImageAndNotification>
                        <S.ContainerImage>
                            <img src={IconWarning} alt="Alerta" />
                        </S.ContainerImage>

                        <S.Notification>
                            <Auxiliar color={theme.colors.red.Vermelho_erro}>{alert.alerta}</Auxiliar>
                            
                            {!window.location.pathname.startsWith("/fazendas") && (
                                <Tooltip 
                                    content= {alert.farm} 
                                    animation="fade" 
                                    delay={[300, 100]} 
                                    arrow={true} 
                                    theme="light" 
                                    placement="bottom"
                                >
                                    <span> 
                                        <img src={Location} alt="Ícone de marcação de mapa" />
                                        <TaglineP 
                                            color={theme.colors.red.Vermelho_erro} 
                                            fontWeight={800} 
                                            style={{ padding: '0 0.5rem' }}
                                        >
                                                {alert.farm}
                                        </TaglineP>
                                    </span>
                                </Tooltip>
                            )}
                        </S.Notification>
                    </S.ImageAndNotification>
                </S.CardNotification>
            </S.Wrapper>
        </S.Container>
    );
};


export default NewCardNotificationFarm;
